import { useCallback } from "react";

/**
 * Custom hook for GrapesJS integration
 */
export const useGrapesJSIntegration = (selectedHtmlFile: string, isEditMode: boolean) => {

    // Set up global callbacks for GrapesJS
    const setupGrapesJSCallbacks = useCallback((onFileChange: (fileName: string) => void, onSave?: (htmlContent: string, cssContent?: string) => void) => {
        // Only set up callbacks if edit mode is enabled
        if (!isEditMode) {
            return () => {}; // Return empty cleanup function
        }

        // Set up postMessage listener for iframe communication
        const handleMessage = (event: MessageEvent) => {
            if (!event.data || typeof event.data !== 'object') {
                return;
            }

            const { type, htmlContent, cssContent, fileName } = event.data;

            switch (type) {
                case 'GRAPESJS_SAVE':
                    if (onSave) {
                        onSave(htmlContent, cssContent);
                    }
                    break;
                case 'GRAPESJS_FILE_CHANGE':
                    onFileChange(fileName);
                    break;
                default:
                    break;
            }
        };

        // Add event listener for postMessage
        window.addEventListener('message', handleMessage);

        // Cleanup function
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [isEditMode]);

    // Update file selector in iframe
    const updateFileSelector = useCallback((htmlFiles: string[]) => {
        if (isEditMode && htmlFiles.length > 0) {
            setTimeout(() => {
                const iframes = document.querySelectorAll('iframe');
                iframes.forEach(iframe => {
                    try {
                        iframe.contentWindow?.postMessage({
                            type: 'UPDATE_FILE_SELECTOR',
                            htmlFiles: htmlFiles
                        }, '*');
                    } catch (error) {
                        // Ignore cross-origin errors
                        console.error('Error updating file selector:', error);
                    }
                });
            }, 1000);
        }
    }, [isEditMode]);

    return {
        setupGrapesJSCallbacks,
        updateFileSelector
    };
}; 